module.exports = __webpack_public_path__ + "static/media/author.28023ad1.jpg";